import type {Schemas} from 'domainTypes/dto';
import type {ThesaurusNode, ThesaurusNodeDetails} from '../types';
import {parseNote} from './parseNote';

export const mapGrepExtendedConceptDto = (
  code: string,
  {id, type, label, deactivated, note, related}: Schemas.GrepExtendedConcept,
): ThesaurusNode => {
  let details: ThesaurusNodeDetails = {};
  if (note) {
    details = parseNote(note);
  }
  if (related && related.length > 0) {
    details.related = related.map(r => ({...r, code}));
  }
  return {
    id,
    code,
    type,
    label,
    deactivated,
    details,
  };
};
